import { render, staticRenderFns } from "./LmForm.vue?vue&type=template&id=10cb0086&"
import script from "./LmForm.vue?vue&type=script&lang=js&"
export * from "./LmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports